// NLP Entities — neutral pre-crawl placeholder (no client data).
// Populated by a live crawl (full audit or this tab's Run Crawl); the regenerated
// HTML replaces this at runtime once the audit has run.
export const HTML_ENTITIES = `
<div class="sh"><h2>NLP Entities</h2><p>Awaiting live data</p></div>
<div class="sub">
<p class="note note-b" style="margin:16px 0">Connect your WordPress site, then run the full audit (or this tab&rsquo;s <strong>Run Crawl</strong>) to populate <strong>NLP Entities</strong> with live data for your site.</p>
</div>
`;
